<template>
  <div  v-if="content.isLoaded"
        style="min-height: fit-content;"
        class="library-content-header">
    <slot name="navigation">
      <div class="navigation" :class="{ 'details': isDetailsPage }">
        <h3 v-if="!isMobile"
            class="title-five">
          {{ displayName || content.name }}
        </h3>
        <bulma-button-icon  v-if="!isDetailsPage && !isWidgetInfoPage"
                            iconClass="fas fa-info-circle links-color"
                            class="pointer-on-hover mr-1 info-btn"
                            :disabled="noDetailInfo"
                            :text="$t('contentViewerMoreInfo')"
                            @click="emit('infoButtonClicked')"/>
        <bulma-button-icon  v-if="isDetailsPage && !hideBackNavigation"
                            iconClass="fas fa-arrow-left links-color"
                            class="pointer-on-hover mr-1 return-btn"
                            :text="$t('returnToViewer')"
                            @click="emit('backButtonClicked')"/>
      </div>
    </slot>
    <slot name="contentActions">
      <div class="content-action-wrapper">
        <content-actions :content="actionsContent || content"
                         :book="book"
                         :hide-export="hideExport"
                         :report-an-issue-enabled="reportAnIssueEnabled"
                         :report-context="reportContext"
                         :snapshot-context="snapshotContext"/>
      </div>
    </slot>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { watch, ref, onMounted, computed } from 'vue'
import BulmaButtonIcon from "@/components/common/BulmaButtonIcon.vue"
import { useStore } from "vuex"
import contentActions from "@/components/library/content/ContentActions.vue"
import { useBreakpoints } from "@/helpers/responsiveBreakpoints"
import { useInfoLandingPage } from '@/components/widgets/composables/useInfoLandingPage'
const { hasInfoPageOpen } = useInfoLandingPage()
const route = useRoute()
const store = useStore()

const props = defineProps({
  title:{
    type: String,
    required: true
  },
  content: {
    type: Object,
    required: true
  },
  actionsContent: {
    type: Object,
    default: null
  },
  displayName: {
    type: String,
    default: ''
  },
  forceEnableInfo: Boolean,
  hideExport: Boolean,
  hideBackNavigation: Boolean,
  reportContext: {
    type: Object,
    default: null
  },
  snapshotContext: {
    type: Object,
    default: null
  }
})

const isDetailsPage = ref(false)
const book = computed(() => store.state.content.toc.book)
const isWidget = computed(() =>  store.state.auth.isWidget)
const reportAnIssueEnabled = computed( () => store.state.user.contactOwnerEnabled)
const noDetailInfo = computed(() => {
  if (props.forceEnableInfo || props.content.type === 'page') {
    return false
  }
  return !props.content.tags?.total &&
    !props.content.comments?.total &&
    !props.content.related?.total &&
    !props.content.attachments?.total &&
    !props.content.whereused?.total
})
const { width } = useBreakpoints()
const isMobile = computed(() => {
  return width.value <= 768
})

const isWidgetInfoPage = computed(() => {
  return isWidget.value
    ? hasInfoPageOpen.value
    : false
})

function setPageName(route) {
  isDetailsPage.value = route.path.includes('details')
}
watch([route], ([currentRoute]) => {
  setPageName(currentRoute)
})
onMounted(() => {
  setPageName(route)
})
const emit = defineEmits(['infoButtonClicked', 'backButtonClicked'])

</script>
